<template>
  <div>
    <a
      v-if="user && user.roles && user.roles.admin"
      class="ag-nomal-action-menu"
      href="javascript:void(0);"
      @click="editCheckin"
      title="EDIT CHECKIN"
    >
      <i class="material-icons-outlined align-middle">edit</i>
    </a>
    <a
      v-if="user && user.roles && user.roles.admin"
      class="ag-nomal-action-menu"
      href="javascript:void(0);"
      @click="deleteCheckin"
      title="DELETE CHECKIN"
    >
      <i class="material-icons-outlined align-middle">delete</i>
    </a>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["user"])
  },
  methods: {
    editCheckin: function() {
      this.params.context.componentParent.editCheckin(this.params.data);
    },
    deleteCheckin: function() {
      this.params.context.componentParent.deleteCheckin(this.params.data);
    }
  }
};
</script>